import type { ILine } from '../../../../models/line.model';
import type { TransportMode } from '../../../../models/transport-mode.enum';

export class TrafficSituationsFilterHelper {
  public static trafficSituationLinesMatchJourneyLine(lines: ILine[], journeyLineGids: ReadonlySet<string> | undefined): boolean {
    if (!journeyLineGids || journeyLineGids.size === 0) return true;

    return lines.some((line) => line.gid !== undefined && journeyLineGids.has(line.gid));
  }

  private static trafficSituationShouldFallbackToTransportMode(lines: ILine[]): boolean {
    if (lines.length === 0) return true;

    return lines.every((line) => !line.gid);
  }

  public static trafficSituationMatchesJourneyTransportModeFallback(lines: ILine[], journeyTransportModes: TransportMode[] | undefined): boolean {
    if (!this.trafficSituationShouldFallbackToTransportMode(lines)) return false;
    if (lines.length === 0) return true;
    if (!journeyTransportModes || journeyTransportModes.length === 0) return true;

    return journeyTransportModes.some((transportMode) => lines.some((line) => line.transportMode === transportMode));
  }
}

